import { CharacterResult } from "../dto/CharacterResult";

export function sortCharactersByPosition(
  unsortedCharacters: CharacterResult[]
): CharacterResult[] {
  const result = unsortedCharacters.sort(
    (a: CharacterResult, b: CharacterResult) => a.position - b.position
  );

  return result;
}
